import React from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import "./index.css";
import "./font.css";
import ScrmRoutes from "./Routes";
import ScrollToTop from "./components/ScrollToTop";
import { Provider } from "react-redux";
import store from "./store";
import { OidcProvider } from "./context/oidc/OidcContext";
import { AuthProvider } from "./context/auth/AuthContext";

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <OidcProvider>
          <AuthProvider>
            <ScrmRoutes />
            <ScrollToTop />
          </AuthProvider>
        </OidcProvider>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
